import { useParams, useLocation, useHistory } from "react-router-dom";
import "./index.css";
import useServiceAndSport from "../../hooks/useServiceAndSport";
import { Children, useContext, useEffect, useState } from "react";
import { sharedComponentsContext } from "../../context/shared-context";
import MatchHeader from "../../components/MatchHeader/MatchHeader";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Container } from "reactstrap";
import MatchLineup from "../../components/MatchLineup/MatchLineup.component";
import { useQueries, useQuery } from "@tanstack/react-query";
import api from "../../apis";
import Slider from "react-slick";
import MatchStatistics from "../../components/MatchStatistics/MatchStatistics";
import MatchEvents from "../../components/MatchEvents/MatchEvents";
import SampleArrowBtn from "../../components/SampleArrowBtn/SampleArrowBtn";
import { ImgURL } from "../../globalData";
import playerIcon from "../../assets/user.png";
import MatchHeaderLoader from "../../components/MatchHeader/matchHeaderLoader";
import ErrorPage from "../../components/ErrorPage/ErrorPage";
import PredictAfconPlayers from "../../components/PredictAfconPlayers";
import { getUserPhoneNumbers } from "../../globalFn";

const apiFn = (params) => api.matches.get(params);
const apiFnTwo = (team_id, params) => {
  return api.teams.getTeamSquad(team_id, params);
};
const getAllPredictionPlayers = (params) => api.predictAndWin.getAllPredictionForPlayers(params);

const settings = {
  infinite: false,
  draggable: false,
  touchMove: false,
  speed: 900,
  slidesToShow: 4.20,
  slidesToScroll: 4,
  rtl: false,
  nextArrow: (
    <SampleArrowBtn
      arrowDirection="left"
      styles={{
        fontSize: "20px",
        background: "#41B13C",
        borderRadius: "6px",
        border: "unset",
        position: "absolute",
        top: "0px",
        height: "100%",
        right: "-12px",
        zIndex: "15",
        width: "20px",
        opacity: "1",
        color: "white",
      }}
    />
  ),
  prevArrow: (
    <SampleArrowBtn
      styles={{
        fontSize: "20px",
        background: "#41B13C",
        borderRadius: "6px",
        border: "unset",
        position: "absolute",
        top: "0px",
        height: "100%",
        left: "-12px",
        zIndex: "15",
        width: "20px",
        opacity: "1",
        color: "white",
      }}
    />
  ),
  responsive: [
   
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3.20,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.20,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.20,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function AFCONMatchDetails() {
  const { id } = useParams();
  const { pathname } = useLocation();
  const history = useHistory();
  const { sportName, serviceId, sportId } = useServiceAndSport();
  const {
    seasonInfo: { activeSeason },
  } = useContext(sharedComponentsContext);
  const [selectedKey, setSelectedKey] = useState("lineup");
  const [showPredictAndWin, setShowPredictAndWin] = useState(false);
  const [player, setPlayer] = useState({});
  const phoneNum = getUserPhoneNumbers()[0];

  const {
    isLoading,
    isError,
    data = {},
    refetch,
  } = useQuery({
    queryKey: ["afcon-match-info", id],
    queryFn: () => apiFn({ id }, sportName),
    select: ({ data }) => data?.data?.[0],
    enabled: sportName !== null,
    refetchOnWindowFocus: false,
  });


  const teamsId = [data?.team1?.id,data?.team2?.id]
  const allTeamsSquad = useQueries({
    queries : teamsId.map((teamId) => {
      return {
        queryKey: [
          "team-squad",
          sportId,
          data?.season_id,
          data?.tournament_id,
          teamId,
        ],
        queryFn: () =>
          apiFnTwo(teamId, {
            sport_id: 1,
            season_id: data?.season_id,
            tournament_id: data?.tournament_id,
          }),
        select: ({ data }) => data.players.all,
        refetchOnWindowFocus: false,
        enabled: !!Object.keys(data).length && data.matchStatus === 1,
      }
    })
  })

  const {data : getAllpredictionData = [] , isLoading : isLoadingPrediction, refetch :  reftechpredictionPlayersfn} = useQuery({
    queryKey : ["getAll-prediction-Players"],
    queryFn : () => getAllPredictionPlayers({
      msisdn : phoneNum,
      match_id : id,
    }),
    enabled : !!phoneNum,
    refetchOnWindowFocus: false,

  })

  if (isLoading || (allTeamsSquad[0].isLoading && data.matchStatus === 1) || (allTeamsSquad[1].isLoading && data.matchStatus === 1) || (isLoadingPrediction && phoneNum))
    return <MatchHeaderLoader />;
  if (!Object.keys(data).length || (!isLoading && isError))
    return <ErrorPage />;
  
  const handleClickGame = (playerObj) => {
    setShowPredictAndWin(true)
    setPlayer(playerObj)
  }

  
  const isIncludePrediction = (arr1 = [], arr2 = [],teamId) => {
    const arr1WithIncludesProperty = arr1?.map((obj1) =>
    arr2?.includes(obj1.id)
        ? { ...obj1, predicted: true,team_id : teamId }
        : { ...obj1, predicted: false,team_id : teamId },
    );
    
    return arr1WithIncludesProperty;
  };




  return (
    <div className="afcon-match-details">
      <div className="header">
        <Container>
          <div className="match-details">
            <MatchHeader matchInfo={data} matchId={id} refetch={refetch} />
          </div>
        </Container>
        <Nav
          activeKey={selectedKey}
          onSelect={(selectedKey) => setSelectedKey(selectedKey)}
          className="header__navs"
        >
          <Nav.Item>
            <Nav.Link eventKey="lineup">التشكيل</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="match-events">أحداث المباراة</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="match-stats">احصائيات</Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      <div className="body">
        <Container>
          <Tabs activeKey={selectedKey}>
            <Tab eventKey="lineup">
      {data.matchStatus === 1 &&  <div className="game-afcon-2023">
             <div className="game-description">
                <h4>
                  توقع نتيجة المباراة ومن سيسجل الأهداف واكسب مع تويست سبورتس
                </h4>
              </div>
              <div className="player-game">
                <ul>
                  <Slider {...settings}>
                    {Children.toArray(
                      isIncludePrediction(allTeamsSquad[0].data,getAllpredictionData ,data?.team1?.id).map(({ id, image, name ,predicted,team_id}) => (
                        
                          <li className="player-item" key={id}>
                            <figure>
                              <img
                                src={image ? ImgURL(image) : playerIcon}
                                alt="player"
                              />
                              <figcaption>{name}</figcaption>
                            </figure>
                            <div className={`predict__andWin--ButtonWrapper d-flex justify-content-center py-2`}>
                              <button
                                className={`predict__andWin--Button text-capitalize ${predicted ? "hasPredicted" : ""}`}
                                onClick={() =>
                                  handleClickGame({ id, image, name ,team_id})
                                }
                                disabled ={predicted}
                              >
                            { !predicted ? "توقع واكسب" : "تم ارسال توقعك مسبقا"}                              
                          </button>
                            </div>
                          </li>
                        
                      ))
                    )}
                  </Slider>
                </ul>
                <ul>
                  <Slider {...settings}>
                    {Children.toArray(
                      isIncludePrediction(allTeamsSquad[1].data,getAllpredictionData ,data?.team2?.id).map(({ id, image, name ,predicted,team_id}) => (

                          <li className="player-item" key={id}>
                            <figure>
                              <img
                                src={image ? ImgURL(image) : playerIcon}
                                alt="player"
                              />
                              <figcaption>{name}</figcaption>
                            </figure>
                            <div className={`predict__andWin--ButtonWrapper d-flex justify-content-center py-2`}>
                            <button
                                className={`predict__andWin--Button text-capitalize ${predicted ? "hasPredicted" : ""}`}
                                onClick={() =>
                                  handleClickGame({ id, image, name ,team_id})
                                }
                                disabled ={predicted}
                              >
                            { !predicted ? "توقع واكسب" : "تم ارسال توقعك مسبقا"}                              
                          </button>

                            </div>
                          </li>
                          
                      ))
                    )}
                  </Slider>
                </ul>
                
              </div>
              <PredictAfconPlayers
                  player={player}
                  matchId={id}
                  show={showPredictAndWin}
                  onHide={() => setShowPredictAndWin(false)}
                  reftechpredictionfn={reftechpredictionPlayersfn}
                />
             </div>
}
              <div className="lineup">
                <MatchLineup matchInfo={data} matchId={id} />
              </div>
            </Tab>
            <Tab eventKey="match-events">
              <div className="match-events">
                <MatchEvents
                  matchId={id}
                  isLoadingMatchInfo={isLoading}
                  dataMatchInfo={data}
                />
              </div>
            </Tab>
            <Tab eventKey="match-stats">
              <div className="match-stats">
                <MatchStatistics matchId={id} />
              </div>
            </Tab>
          </Tabs>
        </Container>
      </div>
    </div>
  );
}
